import { getCssSizeValue, getHtmlFromRedactorField } from "@/utils/utils"
import styled from "styled-components"
import GridContainer from "@/components/common/GridContainer"
import { BREAKPOINTS } from "@/styles/themeSettings"
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"

const StyledModuleWrapper = styled(GridContainer)`
	row-gap: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		row-gap: ${getCssSizeValue(32)};
	}
`

const StyledTile = styled.div`
	aspect-ratio: 335/140;
	border: 1px solid ${({ theme }) => theme.colors.richBlack};
	color: ${({ theme }) => theme.colors.richBlack};
	display: grid;
	align-items: center;
	padding: ${getCssSizeValue(26, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	ul {
		list-style-type: square;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		padding: ${getCssSizeValue(48, BREAKPOINTS.TABLET)} ${getCssSizeValue(50, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		padding: ${getCssSizeValue(48)} ${getCssSizeValue(28)};
		aspect-ratio: unset;
	}
`

const SIZE_VARIANTS = Object.seal({
	WIDE: "wide",
	SLIM: "slim",
})

function SingleSimpleTile({ tile }) {
	const text = tile?.text || ""
	const variant = tile?.variant || SIZE_VARIANTS.SLIM

	const sizeClassName =
		variant === SIZE_VARIANTS.SLIM ? "col-desktop-4 col-tablet-4 col-mobile-8" : "col-desktop-8 col-tablet-8 col-mobile-8"

	return (
		<StyledTile className={`${sizeClassName} typo-strawford typo-strawford-14`}>
			<div dangerouslySetInnerHTML={getHtmlFromRedactorField(text)} />
		</StyledTile>
	)
}

export default function TilesSimple({ data, paddings, headerDescription }) {
	const id = data?.id || ""
	const tiles = data?.tiles || []

	return (
		<section id={id} className={paddings}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			<StyledModuleWrapper>
				{tiles.map((tile, index) => {
					const id = tile?.id || index
					return <SingleSimpleTile key={id} tile={tile} />
				})}
			</StyledModuleWrapper>
		</section>
	)
}
